import React, { useState, useEffect } from "react";
import { GetShippedOrders } from "../../services/OrderService";
import TrackLabOrdersTable from "./TrackLabOrdersTable";
import CommonLoader from "../common/CommonLoader";
import { NotificationManager } from "react-notifications";
import { TextField, Button, Grid } from "@mui/material";
const TrackLabOrders = () => {
  const [loading, setLoading] = useState(false);
  const [labOrdersData, setLabOrdersData] = useState(null);
  const [filteredOrders, setFilteredOrders] = useState(null);
  const [labOrdersCount, setLabOrdersCount] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState({
    searchText: "",
    startDate: "",
    endDate: "",
    pageNumber: 1,
    pageSize: 25,
  });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const today = new Date();
    const startDateValue = new Date(today);
    startDateValue.setDate(today.getDate() - 15);
    setStartDate(startDateValue.toISOString().split("T")[0]);

    const endDateValue = new Date(today);
    endDateValue.setDate(today.getDate() + 15);
    setEndDate(endDateValue.toISOString().split("T")[0]);
    startDateValue.setDate(today.getDate() - 15);
    endDateValue.setDate(today.getDate() + 15);

    const initialCriteria = {
      searchText: "",
      startDate: startDateValue.toISOString().split("T")[0],
      endDate: endDateValue.toISOString().split("T")[0],
      pageNumber: 1,
      pageSize: 25,
    };
    setSearchCriteria(initialCriteria);
    // getLabOrders();
    getLabOrders(1,25);
  }, []);

  useEffect(() => {
    if (labOrdersData) {
      const filtered = labOrdersData.filter((order) =>
        Object.values(order).some((value) =>
          value?.toString().toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setFilteredOrders(filtered);
    }
  }, [searchText, labOrdersData]);

  const getLabOrders = async (pageNumber,pageSize) => {
    try {
      setLoading(true);
      let response = await GetShippedOrders(
        startDate,
        endDate,
        searchText,
        pageNumber,
        pageSize
      );
      setLabOrdersData(response.results);
      setLabOrdersCount(response.count);
      setFilteredOrders(response.results);
    } catch (err) {
      NotificationManager.error("Error getting orders. " + err, "Error");
    } finally {
      setLoading(false);
    }
  };
  const handleSearchClick = () => {
    if (startDate === "" || endDate === "") {
      NotificationManager.error("Invalid Dates");
      return;
    }
    getLabOrders(searchCriteria.pageNumber,searchCriteria.pageSize);
  };

  const onChangePageSettings = async (pageNumber, pageSize) => {
    const updatedSearchCriteria = {
      ...searchCriteria,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    setSearchCriteria(updatedSearchCriteria);
    getLabOrders(pageNumber, pageSize);
  };
  return (
    <div className="vlp-component-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span className="title"> Track Lab Orders</span>
      </div>
      <hr />
      <div className="columns">
        <div className="column">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Search Criteria"
                variant="outlined"
                fullWidth
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                label="From Date"
                type="date"
                variant="outlined"
                fullWidth
                size="small"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                label="To Date"
                type="date"
                variant="outlined"
                fullWidth
                size="small"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSearchClick}
                style={{ height: "100%" }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
      {filteredOrders !== null && (
        <TrackLabOrdersTable
          labOrdersData={filteredOrders}
          count={labOrdersCount}
          onChange={onChangePageSettings}
        />
      )}
      <CommonLoader loading={loading} />
    </div>
  );
};

export default TrackLabOrders;
